import SurveyListGridContainer from "./SurveyListGridContainer";
export default SurveyListGridContainer;



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/index.js